var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "down-arrow",
    transform: "translate(-2 -6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    "data-name": "Group 495"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M21,18a.908.908,0,0,1-.7-.3L13,10.4,9.7,13.7a.967.967,0,0,1-1.4,0l-6-6a.967.967,0,0,1,0-1.4.967.967,0,0,1,1.4,0L9,11.6l3.3-3.3a.967.967,0,0,1,1.4,0l8,8a.967.967,0,0,1,0,1.4.908.908,0,0,1-.7.3Z",
    fill: "#e84847"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_496",
    "data-name": "Group 496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M21,18H14a1,1,0,0,1,0-2h6V10a1,1,0,0,1,2,0v7A.945.945,0,0,1,21,18Z",
    fill: "#e84847"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendDown);
export default __webpack_public_path__ + "static/media/trendDown.d545dacacfe685944cd40e7301290f96.svg";
export { ForwardRef as ReactComponent };